import React from 'react';
import './QuizMatchPrivacy.css';
import AnimatedSection from './components/AnimatedSection';

function QuizMatchPrivacy() {
  return (
    <AnimatedSection>
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p>Last updated: July 10, 2025</p>
        
        <div className="section">
          <h2>Introduction</h2>
          <p>This Privacy Policy describes how we collect, use, and process your personal information.</p>
        </div>
        
        <div className="section">
          <h2>Information We Collect</h2>
          <p>We collect information you provide directly to us when you use our services.</p>
        </div>
        
        <div className="section">
          <h2>Use of Information</h2>
          <p>The information we collect is used to personalize your experience, fix application bugs, and improve application performance.</p>
        </div>
        
        <div className="section">
          <h2>Sharing of Information</h2>
          <p>We do not share your information with third parties. However, in the event of a legal requirement, information may be shared to comply with legal regulations.</p>
        </div>
        
        <div className="section">
          <h2>Security</h2>
          <p>We take necessary measures to ensure the security of your information. However, we cannot guarantee that data transmissions over the internet are completely secure.</p>
        </div>
        
        <div className="section">
          <h2>Contact Us</h2>
          <p>If you have any questions about our Privacy Policy, please contact us:</p>
          <p><strong>Email:</strong> support@quizmatch.com</p>
        </div>
      </div>
    </AnimatedSection>
  );
}

export default QuizMatchPrivacy;
